import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import useApi from "../hook/useApi";
import { useAuth } from "../context/AuthContext";

const SOCKET_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const MaintenanceGuard = ({ children, panelType }) => {
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);
  const { AsyncGetApiCall } = useApi();
  const { subAdminId, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const result = await AsyncGetApiCall("/system-config");
        if (result?.success && result?.data) {
          const { maintenanceMode } = result.data;
          
          let blocked = maintenanceMode.all;
          if (!blocked) {
            if (panelType === "master") blocked = maintenanceMode.master;
            else if (panelType === "broker") blocked = maintenanceMode.broker;
            else if (panelType === "user") blocked = maintenanceMode.user;
          }

          // ONLY block if it's a Sub-Admin (Master). Super-Admins (subAdminId = false) are exempt.
          setIsUnderMaintenance(!!(blocked && subAdminId));
        }
      } catch (e) {
        console.error("Maintenance check failed", e);
      } finally {
        setLoading(false);
      }
    };

    checkMaintenance();

    // Listen for real-time config updates via WebSockets
    const socket = io(SOCKET_URL, { reconnection: true });
    socket.on("system_config_updated", (config) => {
      if (config?.maintenanceMode) {
        let blocked = config.maintenanceMode.all;
        if (!blocked) {
          if (panelType === "master") blocked = config.maintenanceMode.master;
          else if (panelType === "broker") blocked = config.maintenanceMode.broker;
          else if (panelType === "user") blocked = config.maintenanceMode.user;
        }
        setIsUnderMaintenance(!!(blocked && subAdminId));
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [panelType, subAdminId, location.pathname]);

  if (loading) return null;

  if (isUnderMaintenance) {
    return (
      <div className="maintenance-wrapper d-flex align-items-center justify-content-center vh-100 bg-base">
        <div className="text-center p-24 card shadow-sm radius-12 border-0" style={{ maxWidth: '450px' }}>
          <Icon icon="tabler:settings-automation" className="text-danger mb-16" style={{ fontSize: '64px' }} />
          <h3 className="mb-8 fw-bold">System Under Maintenance</h3>
          <p className="text-secondary-light mb-24">The Master Panel is currently undergoing scheduled maintenance. Please try again later or contact support.</p>
          <div className="d-flex gap-12 justify-content-center">
            <button 
              onClick={() => logout(subAdminId ? "true" : "")} 
              className="btn btn-primary-600 radius-8 px-24"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default MaintenanceGuard;
